import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DxPopupComponent } from 'devextreme-angular/ui/popup';
import {
    InventoryProduct,
    ProductLookupService,
    UtilService,
} from 'src/app/shared/services';
import { FormatNumberPipe } from 'src/app/shared/pipes/format-number.pipe';
import { FormatRelativeDatetimePipe } from 'src/app/shared/pipes/format-relative-datetime.pipe';

// A popup showing one lnwshop product — picture, price, stock, and links to
// the storefront, the lnwstore back office and each marketplace listing —
// looked up by seller SKU. A page drops one instance in its template and
// calls open(sku) from wherever it renders a SKU.
@Component({
    selector: 'app-product-card-popup',
    templateUrl: './product-card-popup.component.html',
    styleUrls: ['./product-card-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxPopupComponent, FormatNumberPipe, FormatRelativeDatetimePipe],
})
export class ProductCardPopupComponent {
    private cdref = inject(ChangeDetectorRef);
    private destroyRef = inject(DestroyRef);
    private productLookupService = inject(ProductLookupService);
    private utilService = inject(UtilService);

    visible = false;
    sku = '';
    product: InventoryProduct | null = null;
    loading = false;
    error = '';

    // Looks the SKU up and shows it. Results are cached by the lookup
    // service, so reopening a card is instant.
    open(sku: string): void {
        this.sku = sku;
        this.product = null;
        this.error = '';
        this.loading = true;
        this.visible = true;
        this.productLookupService
            .findBySku(sku)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (product) => {
                    // A slower lookup for an earlier SKU must not overwrite
                    // the card the operator has since opened.
                    if (this.sku !== sku) {
                        return;
                    }
                    this.product = product;
                    this.loading = false;
                    this.cdref.markForCheck();
                },
                error: (error: unknown) => {
                    if (this.sku !== sku) {
                        return;
                    }
                    this.loading = false;
                    this.error = this.utilService.errorToString(error);
                    this.cdref.markForCheck();
                },
            });
    }
}
